<div class="cx-breadcrumb container">
  @if (links().length <= 0) {
    <skeleton-loading class="cx-breadcrumb-loading" />
  } @else {
    <ul class="cx-breadcrumb__list">
      @for (link of links(); track $index) {
        @if (!$last) {
          <li class="cx-breadcrumb__list--item">
            <a [routerLink]="link.routerLink">
              {{ link.linkName }}
            </a>
          </li>

          <li class="cx-breadcrumb__list--item">
            <span class="material-symbols-outlined icon">chevron_right</span>
          </li>
        } @else {
          <li class="cx-breadcrumb__list--item">
            {{ link.linkName }}
          </li>
        }
      }
    </ul>
  }
</div>
